import React from "react";
import ExploreInfo from "../explore-info/ExploreInfo";
import { StyledMyExplore } from "./MyExplore.styled";

function MyExplore() {
  return (
    <StyledMyExplore>
      <ExploreInfo />
    </StyledMyExplore>
  );
}

export default MyExplore;
